import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useScreenContext } from "../Layout";

const statsImage: any = {
  br: require("../../assets/images/stats.br.png"),
  en: require("../../assets/images/stats.en.png"),
  es: require("../../assets/images/stats.es.png"),
};

function ReadingStats() {
  const { t, i18n } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: "time-saved",
      progress: 42,
    }));
  }, []);

  return (
    <div>
      <h1 className="mb-4 mt-5 text-4xl font-bold tracking-tight text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
        {t("reading_stats.headline.part_1")}{" "}
        <span className="text-blue-600">
          {t("reading_stats.headline.part_2")}
        </span>{" "}
        {t("reading_stats.headline.part_3")}
      </h1>
      <img
        className="mx-auto py-10"
        alt="Chart showing your progress"
        src={statsImage[i18n.language]}
      />
    </div>
  );
}

export default ReadingStats;
